<template>
  <a v-show="geolocationAvailable" :class="{ 'screenReaderOnly': !isVisible }" class="geolocationButton" href="#" @click.prevent="getUserLocation" :alt="altText">
    <div class="geolocation" :title="altText" :aria-label="altText"></div>
  </a>
</template>

<script>

export default {
  props: {
    updateLocation: {
      type: Function,
      default: () => {}
    },
    isVisible: {
      type: Boolean,
      default: false
    },
    showLoading: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      altText: 'Find congressional districts near me',
      geolocationAvailable: true
    }
  },
  created() {
    this.geolocationAvailable = navigator.geolocation ? true : false;
  },
  methods: {
    getUserLocation () {
      if (this.geolocationAvailable) {
        this.showLoading ? this.showLoading(true) : null;
        navigator.geolocation.getCurrentPosition(this.updateUserLocation, this.errorUserLocation);
      }
    },
    updateUserLocation (position) {
      let location = L.latLng(position.coords.latitude, position.coords.longitude);
      if (typeof this.updateLocation == 'function') {
        this.updateLocation(location);
      }
    },
    errorUserLocation (error) {
      this.showLoading ? this.showLoading(false) : null;
      console.error(error);

      this.showErrorMessage(error)
    },
    showErrorMessage (error) {
      let message = error.message || '';
      switch(error.code) {
        case error.PERMISSION_DENIED:
          message = "User denied the request for Geolocation."
          this.geolocationAvailable = false;
          break;
        case error.POSITION_UNAVAILABLE:
          message = "Location information is unavailable."
          this.geolocationAvailable = false;
          break;
        case error.TIMEOUT:
          message = "The request to get user location timed out."
          break;
        case error.UNKNOWN_ERROR:
          message = "An unknown error occurred."
          break;
      }
      alert(message)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/variables.scss';

.geolocationButton {
  position: absolute;
  top: 5px;
  right: 3px;
  background: white;
  border-left: 1px solid $lightGray;
  box-sizing: border-box;
  padding: 7px 10px;
  cursor: pointer;
  z-index: 1001;
}
.geolocation {
  background-image: url('../assets/icons/icon-location-999999.svg');
  background-size: cover;
  width: 20px;
  height: 20px;
}
.geolocationButton:hover {
  background: $hoverBackgroundColor;
  border-width: 0;
  border-radius: 3px;
  .geolocation {
    background-image: url('../assets/icons/icon-location-2d9cdb.svg');
  }
}

.mq-mobile {
  .geolocationButton {
      padding-left: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Geolocation.vue